import { useState } from 'react';
import { Content } from 'src/contexts/ContentContext';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './DialogSuppression.css';
import { DialogSuppressionForm } from './DialogSuppressionForm';

export const DialogSuppression = () => {
  const [isFormDirty, setIsFormDirty] = useState(false);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.pageName}>
          <Content id={ContentId.DialogSuppression} />
        </div>
        <div className={styles.pageDescription}>
          <Content id={ContentId.DialogSuppressionDescription} />
        </div>
      </div>

      <div className={styles.body}>
        <DialogSuppressionForm
          onDirtyStateChange={setIsFormDirty}
          isFormDirty={isFormDirty}
        />
      </div>
    </div>
  );
};
